import { render, staticRenderFns } from "./record_list.vue?vue&type=template&id=2a6e62e7&scoped=true"
import script from "./record_list.vue?vue&type=script&lang=js"
export * from "./record_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6e62e7",
  null
  
)

export default component.exports